import { Alert, Button, Flex, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

interface CredentialsFormProps {
  error: string;
  info: string;
  initialEmail?: string;
  onCancel: () => void;
  onForgotPassword: () => void;
  onSubmit: (values: { email: string; password: string }) => void;
}

export const CredentialsForm = ({
  initialEmail,
  error,
  info,
  onSubmit,
  onForgotPassword,
  onCancel,
}: CredentialsFormProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <Form<{ email: string; password: string }>
      initialValues={{ email: initialEmail }}
      onFinish={onSubmit}
      layout="vertical"
    >
      <Flex vertical gap="middle">
        {(error || info) && (
          <Alert
            type={error ? "error" : "success"}
            title={error || info}
            showIcon
          />
        )}

        <Form.Item
          name="email"
          label={t("idpDiscovery.emailLabel")}
          rules={[
            { required: true, message: t("labels.emailRequired") },
            { type: "email", message: t("labels.emailInvalid") },
          ]}
        >
          <Input
            type="email"
            placeholder={t("idpDiscovery.emailPlaceholder")}
            size="large"
            autoComplete="username"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={t("passwordLogin.passwordLabel")}
          rules={[
            {
              required: true,
              message: t("passwordLogin.passwordRequired"),
            },
          ]}
        >
          <Input.Password size="large" autoComplete="current-password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            {t("passwordLogin.signIn")}
          </Button>
        </Form.Item>

        <Button type="link" block onClick={onForgotPassword}>
          {t("passwordLogin.forgotPassword.link")}
        </Button>

        <Button type="link" block onClick={onCancel}>
          {t("idpDiscovery.useDifferentEmail")}
        </Button>
      </Flex>
    </Form>
  );
};
